module.exports = __webpack_public_path__ + "img/demo-customization-overload.f9ad5805.png";